import React, { useState } from "react";
import SidebarField from "../../../Components/SidebarField";
import Button from "../../../Components/Button";
import { Form, Formik } from "formik";
import { FaPen, FaPencilAlt } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { ResourceApi } from "../../../App/api/Resources.apis";
import { toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { IoEyeOutline } from "react-icons/io5";

const ResourceCard = ({
  resource,
  onEdit,
  getAllResources,
  handleDeleteModel,
}) => {
  const [isCardOpen, setIsCardOpen] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);

  const getYouTubeEmbedLink = (url) => {
    const videoIdMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.*\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    return videoIdMatch
      ? `https://www.youtube.com/embed/${videoIdMatch[1]}`
      : url;
  };
  // const toggleCard = () => {
  //   setIsOpen(!isOpen);
  // };
  const handleSubmit = (values) => {
    console.log("course form value:", values);
  };

  const formatLabel = (input) => {
    return input
      .map((item) =>
        String(item)
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      )
      .join(", ");
  };

  const handleClicked = (resource) => {
    console.log(resource);
    handleDeleteModel(resource?._id);
    getAllResources();
  };

  return (
    <div className="">
      <div className="n-card flex-col justify-between  shadow-lg w-full sm:w-50 h-auto sm:h-100 m-4 rounded-lg p-4 border hover:shadow-xl cursor-pointer transition-all">
        {/* Card Header */}
        <div>
          <iframe
            width="100%"
            height="200"
            src={getYouTubeEmbedLink(resource.introVideoLink)}
            title="Intro Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>

          <h2 className="text-xl font-bold text-gray-800 mb-2">
            {resource.title}
          </h2>
          <p className="text-gray-600">
            <strong>Target Audience:</strong>{" "}
            {resource.targetAudience.join(", ")}
          </p>
          <p className="text-gray-600">
            <strong>Level:</strong> {resource.courseLevel}
          </p>

          <div className="flex items-center justify-between flex-row-reverse mt-4">
            <div className="flex justify-end items-center">
              <MdOutlineDelete
                className="m-1 text-[1.5rem] hover:text-red-500"
                onClick={() => handleClicked(resource)}
              />
              <FaPencilAlt
                className="m-1  text-[1rem] hover:text-blue-500"
                onClick={onEdit}
              />
            </div>
            <div className="flex items-center space-x-3">
              <p className="text-gray-700 font-semibold">
                {isPrivate ? "Private" : "Public"}
              </p>
              <button
                className={`relative inline-flex h-6 w-12 rounded-full border-2 transition-all ${
                  isPrivate
                    ? "bg-green-500 border-green-500"
                    : "bg-gray-300 border-gray-300"
                }`}
                onClick={() => setIsPrivate(!isPrivate)}
              >
                <span
                  className={`absolute h-5 w-5 bg-white rounded-full shadow-md transform transition-transform ${
                    isPrivate ? "translate-x-6" : "translate-x-0"
                  }`}
                ></span>
              </button>
            </div>
          </div>

          {/* <p className="text-gray-600">
        <strong>Intro Video:</strong>{" "}
        <a
          href={resource.introVideoLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 underline"
        >
          Watch Video
        </a>
      </p> */}

          {/* Expandable Details */}
          {/* {isOpen && (
        <div>
        <Formik
          initialValues={initialValues}
        //   validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ handleChange, values, handleSubmit, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={()=>setIsOpen(false)}
                title={resource?._id
                    ? `Update Category`
                    : `Add New Category`
                }
                button1={
                  <Button text="Cancel" type="button" onClick={()=>setIsOpen(false)} />
                }
                button2={
                  <Button
                    text={resource?._id ? "Update" : "Add"
                    }
                  />
                }
              >
        <div className="mt-4">
          <p className="text-gray-600">
            <strong>Author:</strong> {resource.author}
          </p>
          <p className="text-gray-600">
            <strong>Category:</strong> {resource.cashCropCategory}
          </p>
          <p className="text-gray-600">
            <strong>Course Details:</strong> {resource.courseDetails}
          </p>
          <div className="mt-4">
            <h3 className="text-lg font-semibold">Syllabus Details:</h3>
            <p className="text-gray-600">
              <strong>Duration:</strong>{" "}
              {resource.syllabusDetails.courseDuration}
            </p>
            {resource.syllabusDetails.syllabus.map((module, index) => (
              <div key={module._id} className="mt-2 bg-gray-50 p-3 rounded">
                <p>
                  <strong>Module {index + 1}:</strong> {module.title}
                </p>
                <p>
                  <strong>Duration:</strong> {module.duration}
                </p>
                <p>
                  <strong>Video:</strong>{" "}
                  <a
                    href={module.video}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline"
                  >
                    Watch
                  </a>
                </p>
                <p>
                  <strong>Materials:</strong>
                  <ul className="list-disc ml-5">
                    {module.downloadableMaterials.map((material) => (
                      <li key={material._id}>
                        <a
                          href={material.file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 underline"
                        >
                          Download
                        </a>
                      </li>
                    ))}
                  </ul>
                </p>
              </div>
            ))}
          </div>
          <p className="text-gray-600 mt-2">
            <strong>Certification:</strong>{" "}
            {resource.syllabusDetails.certification ? "Yes" : "No"}
          </p>
        </div>
        </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
      )} */}
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;
